import { useConfirm } from "material-ui-confirm";

import { AllIntegrationTypes } from "~frontend/__generated__/graphql";
import {
  DELETE_INTEGRATION,
  LIST_INTEGRATIONS,
} from "~frontend/graphql/integration";
import useMutation from "~frontend/util/useMutation";

export const useDeleteIntegration = (): {
  handleIntegrationDelete: (integration: AllIntegrationTypes) => Promise<void>;
} => {
  const [deleteIntegration] = useMutation(DELETE_INTEGRATION, {
    refetchQueries: [LIST_INTEGRATIONS],
    awaitRefetchQueries: true,
  });

  const confirm = useConfirm();

  async function handleIntegrationDelete(integration: AllIntegrationTypes) {
    const { confirmed } = await confirm({
      title: "Delete Integration",
      description: `Are you sure you want to delete the integration: "${integration.name}"?`,
    });
    if (!confirmed) {
      return;
    }

    const { errors } = await deleteIntegration({
      variables: { input: { integrationId: integration.id } },
    });

    if (errors) {
      throw errors;
    }
  }

  return { handleIntegrationDelete };
};
